<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import ButtonQC from '@qicgroupdoha/qic-connect-ds/components/ButtonQC'
  import LoaderQC from '@qicgroupdoha/qic-connect-ds/components/LoaderQC'
  import QuoteApplePayButton from '../payment-buttons/QuoteApplePayButton.vue'
  import QuoteGooglePayButton from '../payment-buttons/QuoteGooglePayButtonV2/QuoteGooglePayButtonV2.vue'

  interface Props {
    paymentMethod: number
    isLoading: boolean
    loadingPrice: boolean
    quoteTotalPrice: number
    quoteNumber: string
    acceptance: boolean
    validateBeforePayment: () => Promise<boolean>
    getApplePayTotalCallback: () => number
    isGpayOrApplePay: boolean
  }

  defineProps<Props>()

  const emit = defineEmits<{
    (e: 'submit'): void
    (e: 'start-pay'): void
    (e: 'acceptance-error'): void
    (e: 'gpay-enabled'): void
    (e: 'error', value: string): void
  }>()

  const { locale } = useI18n()
</script>

<template>
  <div v-show="!isLoading && !loadingPrice" class="quote__payment-button">
    <ButtonQC
      v-if="!isGpayOrApplePay"
      wide
      :icon-after-content="locale === 'en' ? 'arrow-narrow-right' : 'arrow-narrow-left'"
      variant="primary"
      size="large"
      data-test="checkout-button"
      @click="emit('submit')"
    >
      {{ $t('qic_quote_checkout_button') }}
    </ButtonQC>

    <QuoteApplePayButton
      :show-btn="paymentMethod === 2"
      :total-price="quoteTotalPrice || 0.0"
      :quote-number="quoteNumber"
      :acceptance="acceptance"
      :validate-before-payment="validateBeforePayment"
      :get-total-call-back="getApplePayTotalCallback"
      @start-pay="acceptance ? emit('start-pay') : emit('acceptance-error')"
      @succeed-payment="emit('submit')"
    />

    <QuoteGooglePayButton
      v-show="paymentMethod === 3"
      :total-price="quoteTotalPrice || 0.0"
      :acceptance="acceptance"
      :validate-before-payment="validateBeforePayment"
      :quote-number="quoteNumber"
      @google-pay-enabled="emit('gpay-enabled')"
      @start-pay="emit('start-pay')"
      @succeed-payment="emit('submit')"
      @acceptance-error="emit('acceptance-error')"
      @error="emit('error', $event)"
    />
  </div>

  <LoaderQC
    v-show="isLoading || loadingPrice"
    variant="primary"
    size="extraLarge"
    class="quote__payment-loader"
  />
</template>
